module.exports = __webpack_public_path__ + "img/avatar6.65f13ae1.png";